<template>
  <div class="col-12">
    <b-button
    class="btn btn-block mb-3 btn-primary"
    @click="show"
    >
      Saisir des labels
    </b-button>
    <b-modal
    v-model="showModal"
    lazy
    ok-title="Valider"
    cancel-title="Annuler"
    @ok="submit"
    @shown="on_shown"
    @hide="on_hide"
    title="Saisir des labels"
    >
      <p class="mb-0">Titre</p>
      <b-form-group>
        <multiselect
          v-model="form.titre"
          :options="titres"
          :multiple="true"
          label="associationlabel_libelle"
          track-by="associationlabel_libelle"
          placeholder="sélectionner un ou plusieurs titres"
          selectLabel=""
          selectedLabel=""
          deselectLabel=""
        >
          <template #noResult>
            <span>Aucun résultat</span>
          </template>
        </multiselect>
      </b-form-group>

      <p class="mt-4 mb-0">Statut</p>
      <b-form-group>
        <multiselect
          v-model="form.statut"
          :options="statuts"
          :multiple="true"
          label="associationlabel_libelle"
          track-by="associationlabel_libelle"
          placeholder="sélectionner un ou plusieurs statuts"
          selectLabel=""
          selectedLabel=""
          deselectLabel=""
        >
          <template #noResult>
            <span>Aucun résultat</span>
          </template>
        </multiselect>
      </b-form-group>

      <p class="mt-4 mb-0">Qualification</p>
      <b-form-group>
        <multiselect
          v-model="form.qualification"
          :options="qualifications"
          :multiple="true"
          label="associationlabel_libelle"
          track-by="associationlabel_libelle"
          placeholder="sélectionner une ou plusieurs qualifications"
          selectLabel=""
          selectedLabel=""
          deselectLabel=""
        >
          <template #noResult>
            <span>Aucun résultat</span>
          </template>
        </multiselect>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  data: () => ({
    showModal: false,
    form: {
      titre: [],
      statut: [],
      qualification: []
    }
  }),
  created () {
    this.on_shown()
  },
  computed: {
    id () {
      return `modal-label-${this._uid}`
    },
    concours () {
      return this.$sync.json['concours'][this.$route.params.concours_id] || {}
    },
    epreuve () {
      return this.$sync.json['concours'][this.$route.params.concours_id]['epreuves'][this.$route.params.epreuve_id] || {}
    },
    engagement () {
      return this.$sync.json['concours'][this.$route.params.concours_id]['epreuves'][this.$route.params.epreuve_id]['engagements'][this.$route.params.engagement_id] || {}
    },
    horse_id () {
      return this.engagement.horse_id
    },
    titres () {
      let data = []
      const titres = this.epreuve.titres
      Object.keys(titres).forEach(key => {
        data.push({ epreuvetypelabel_id: titres[key].epreuvetypelabel_id, associationlabel_libelle: titres[key].associationlabel_libelle })
      })

      return data
    },
    statuts () {
      let data = []
      const statuts = this.epreuve.statuts
      Object.keys(statuts).forEach(key => {
        data.push({ epreuvetypelabel_id: statuts[key].epreuvetypelabel_id, associationlabel_libelle: statuts[key].associationlabel_libelle })
      })

      return data
    },
    qualifications () {
      let data = []
      const qualifications = this.epreuve.qualifications
      Object.keys(qualifications).forEach(key => {
        data.push({ epreuvetypelabel_id: qualifications[key].epreuvetypelabel_id, associationlabel_libelle: qualifications[key].associationlabel_libelle })
      })

      return data
    }
  },
  methods: {
    show () {
      this.showModal = true
    },
    on_shown () {
      this.form.titre = []
      this.form.statut = []
      this.form.qualification = []
      const engagement = this.engagement
      if (engagement.engagement_titre) {
        const titre = JSON.parse(engagement.engagement_titre)
        for (let i = 0; i < titre.length; i++) {
          this.form.titre.push({ epreuvetypelabel_id: this.epreuve.titres[titre[i]].epreuvetypelabel_id, associationlabel_libelle: this.epreuve.titres[titre[i]].associationlabel_libelle })
        }
      }

      if (engagement.engagement_statut) {
        const statut = JSON.parse(engagement.engagement_statut)
        for (let i = 0; i < statut.length; i++) {
          this.form.statut.push({ epreuvetypelabel_id: this.epreuve.statuts[statut[i]].epreuvetypelabel_id, associationlabel_libelle: this.epreuve.statuts[statut[i]].associationlabel_libelle })
        }
      }

      if (engagement.engagement_qualification) {
        const qualification = JSON.parse(engagement.engagement_qualification)
        for (let i = 0; i < qualification.length; i++) {
          this.form.qualification.push({ epreuvetypelabel_id: this.epreuve.qualifications[qualification[i]].epreuvetypelabel_id, associationlabel_libelle: this.epreuve.qualifications[qualification[i]].associationlabel_libelle })
        }
      }
    },
    hide () {
      this.showModal = false
    },
    on_hide () {
      this.on_shown()
    },
    async submit () {
      const args = this.$route.params
      let path = `/concours/${args.concours_id}/epreuves/${args.epreuve_id}/engagements/${args.engagement_id}/engagement_titre`
      const meta_data = {
        engageurs: this.engagement.engagement_engageur,
        horses: this.horse_id
      }
      this.$sync.update_json(
        path,
        JSON.stringify(this.form.titre.map((x) => x.epreuvetypelabel_id)),
        'concours',
        true,
        meta_data
      )

      path = `/concours/${args.concours_id}/epreuves/${args.epreuve_id}/engagements/${args.engagement_id}/engagement_statut`
      this.$sync.update_json(
        path,
        JSON.stringify(this.form.statut.map((x) => x.epreuvetypelabel_id)),
        'concours',
        true,
        meta_data
      )

      path = `/concours/${args.concours_id}/epreuves/${args.epreuve_id}/engagements/${args.engagement_id}/engagement_qualification`
      this.$sync.update_json(
        path,
        JSON.stringify(this.form.qualification.map((x) => x.epreuvetypelabel_id)),
        'concours',
        true,
        meta_data
      )
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
